module.exports = "/_next/static/images/Hero@2x-014baba198ba4f5d68915fe863ab721f.png";